import { RetornoRelatorio } from "@/types/relatorios/retorno-relatorio";
import { Service } from "./mainService";
import { PortalError } from "@/types/portal-error";
import { FiltrosGestao } from "@/types/relatorios/filtros-gestao";

const reportService = {
  getReciboPca,
  prepararFppc,
  getFppc,
  prepararSm2v,
  getSm2v,
  prepararIepm,
  getReciboProtocolo,
  prepararRCL,
  getRCL,
  getExerciciosRCL,
  getRelatorioGestao,
  preparaAMMD,
  prepararTMS,
};

async function getReciboPca(idPrestacaoConta): Promise<RetornoRelatorio> {
  const url = `${process.env.VUE_APP_REPORTS_API}/relatorio/relatoriopca?idPCA=${idPrestacaoConta}&nomeRel=ReciboPCA`;
  const response = await Service.$http.get(url);
  if (response.status === 200) {
    return response.data;
  }
  console.error("Falha ao carregar recibo de pca", response);
  throw new PortalError(
    response.data?.msg ?? "Erro ao carregar recibo, por favor tente novamente"
  );
}

async function getReciboProtocolo(idRecibo) {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API +
      "/relatorio/reciboProtocolo/" +
      idRecibo,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function prepararFppc(exercicio) {
  const url =
    exercicio == null
      ? "/relatorio/prepararfppc/"
      : "/relatorio/prepararfppc/" + exercicio;
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API + url
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function getFppc(filtros) {
  const data = filtros;
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_REPORTS_API +
      "/relatorio/fppc/" +
      filtros.exercicio +
      "/" +
      filtros.mesInicio +
      "/" +
      filtros.mesFim +
      "/" +
      filtros.cpf,
      data,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function prepararSm2v() {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API + "/relatorio/prepararsm2v/"
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function getSm2v(filtros) {
  const data = filtros;
  try {
    const response = await Service.$http.post(
      `${process.env.VUE_APP_REPORTS_API}/relatorio/sm2v/${filtros.exercicio}/${filtros.mes}/${filtros.idArea}/${filtros.formato}`,
      data,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function prepararIepm() {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API + "/relatorio/preparariepm/"
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function prepararRCL(exercicio) {
  try {
    const url =
      exercicio == null
        ? "/relatorio/prepararrcl/"
        : "/relatorio/prepararrcl/" + exercicio;
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API + url
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function getRCL(filtros) {
  const data = filtros;
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_REPORTS_API +
      "/relatorio/rcl/" +
      filtros.exercicio +
      "/" +
      filtros.mes,
      data,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function getExerciciosRCL() {
  try {
    const url = "/relatorio/exerciciosrcl/";
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API + url
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function getRelatorioGestao(
  nomeRel: string,
  filtros: FiltrosGestao,
  extensao = "PDF"
): Promise<RetornoRelatorio> {
  const response = await Service.$http.post(
    process.env.VUE_APP_REPORTS_API +
    `/relatorio/relatorioGestao/${nomeRel}/${extensao}`,
    filtros.toFormData()
  );
  if (response.status === 200) {
    return response.data;
  }
  console.error("Falha ao carregar relatório de gestão", response);
  throw new PortalError(
    response.data?.msg ??
    "Erro ao carregar relatório, por favor tente novamente"
  );
}

async function preparaAMMD(ano: string | number | null) {
  try {
    const url = ano
      ? `/relatorio/prepararammd/${String(ano)}`
      : '/relatorio/prepararammd'
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API + url
    );
    return response.data;
  } catch (e: any) {
    return e.response;
  }
}

async function prepararTMS(ano: string | number | null) {
  try {
    const url = ano
      ? `/relatorio/preparartms/${String(ano)}`
      : '/relatorio/preparartms'
    const response = await Service.$http.get(
      process.env.VUE_APP_REPORTS_API + url
    );
    return response.data;
  } catch (e: any) {
    return e.response;
  }
}

export default reportService;
